import type { Customer } from "../../../shared/models/customer";
import { createDataStore } from "../lib/data_store";
import { get, post } from "aws-amplify/api";
import { API_NAME } from "../lib/amplify";
import { extractApiError } from "../lib/api_error";

const customerStore = createDataStore<Customer[] | undefined>();

export const useCustomers = customerStore.useData;
export const setCustomers = customerStore.setData;

export async function fetchCustomers(): Promise<void> {
  try {
    const { body } = await get({
      apiName: API_NAME,
      path: "/admin/list-customers",
    }).response;
    const data = (await body.json()) as unknown as {
      customers: Customer[];
    };
    setCustomers(data.customers);
  } catch (err) {
    throw new Error(await extractApiError(err));
  }
}

export async function createCustomer(name: string): Promise<Customer> {
  try {
    const { body } = await post({
      apiName: API_NAME,
      path: "/admin/create-customer",
      options: {
        body: { name },
      },
    }).response;
    const customer = (await body.json()) as unknown as Customer;
    customerStore.updateData((current) => [...(current ?? []), customer]);
    return customer;
  } catch (err) {
    throw new Error(await extractApiError(err));
  }
}
